export default __webpack_public_path__ + "static/noun_dot_3894734-dd8bd2662fafa4407a60c313249714c5.png";